<template>
  <Modal 
    :id="'cmp-catalog-licence-add-account'" 
    @cancelled="onCancel"
  >
    <template slot="header">Batch {{$t('licence_reminder')}} </template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'year'"
          v-bind="textFieldConfig"
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          :value="licenceObject.year"
          :placeholder="$t('year')"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
         
        />
        <Dropdown
           required
           :showValidationIcons="true"
           :immediateValidation="true"
           :id="'accounting_period'"
           class="m2"
           :options="accountingPeriodTV"
           :selected="
              accountingPeriodTV.find(
                (x) => x.value == licenceObject.accounting_period
              )
            "
            :placeholder="$t('accounting')"
           box
           deselect
           @selectedChange="(e) => onDropdownChange('accounting_period', e)"
           @validated="(e) => onValidation('accounting_period', e)"
        ></Dropdown> 
        <Dropdown
           required
           :showValidationIcons="true"
           :immediateValidation="true"
           :id="'period'"
           class="m2"
           :options="periodTV"
           :selected="
              periodTV.find(
                (x) => x.value == licenceObject.period
              )
            "
            :placeholder="$t('Period')"
           box
           deselect
           @selectedChange="(e) => onDropdownChange('period', e)"
           @validated="(e) => onValidation('period', e)"
        ></Dropdown> 

        <TextField
          class="m1"
          :id="'email'"
          textarea
          v-bind="textFieldConfig"
          :height="120"
          :value="licenceObject.email"
          :placeholder="$t('email')"
          @valuechanged="onTextFieldValueChange"
         
        />

      </div>
    </template>
    <template slot="options">
   
      <button 
        class="dt-button s6" 
        @click.stop="onCancel"
      >Cancel</button>
         <button
        class="dt-button v1 with-ico"
         :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="addNewLicenceAccount"
      >
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>

<script>

import Modal from '@dtplugins/modal/modal';
import { licenceAccountsService } from '../../services/licence-accounts.service';

import {
  createTV,
  tv,
} from "../../../../models/text-value.model";
export default {
  components: {
    Modal,
  },
  props: {
    
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        // showValidationIcons: true,
        // immediateValidation: true,
      },
      licenceObject:{
        email: null,
        year: null,
        accounting_period:null,
        period:null,
      },
      
      
      
      // licenceStatuses:[],
      validationResult: {},
    };
  },
  mounted:async function() {
    // const res=await licenceAccountsService.createLicenceAccount();  
    // this.licenceStatuses=res.data.licence_statuses;
    // console.log("WERE",res);
  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e?.valid);
    },
    accountingPeriodTV:function(params) {
      return [
        {text:'Bi annualy' , value:'bi_annually' },
        {text:'Quaterly' , value:'quaterly' },
        {text:'Monthly' , value:'monthly' }
      ];
    },
    periodTV:function(){
      if(this.licenceObject.accounting_period=='bi_annually'){
        return [
          {text:'H1' , value:6 },
          {text:'H2' , value:12 },
          
        ];
      }else if(this.licenceObject.accounting_period=='quaterly'){
        
        return [
          {text:'Q1' , value:3 },
          {text:'Q2' , value:6 },
          {text:'Q3' , value:9 },
          {text:'Q4' , value:12 },
          
        ];
      }else if(this.licenceObject.accounting_period=='monthly'){
          return [
            {text:'M1' , value:1 },
            {text:'M2' , value:2 },
            {text:'M3' , value:3 },
            {text:'M4' , value:4 },
            {text:'M5' , value:5 },
            {text:'M6' , value:6 },  
            {text:'M7' , value:7 },
            {text:'M8' , value:8 },
            {text:'M9' , value:9 },
            {text:'M10' , value:10 },
            {text:'M11' , value:11 },
            {text:'M12' , value:12 },
          ];
      }else{
        return[];
      }

    }

  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onDropdownChange: function (name, value) {      // <-- Normal Form Handling Methods
      this.licenceObject[name]=value.value
      console.log(name,value,this[name])
    },
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this.licenceObject[key]=value;
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    addNewLicenceAccount: async function(e) {
      console.log()
      this.$router.push({
        ...this.$route,
        query: {
          modal: "licence_batch_reminder",
          payload: {...this.licenceObject}
        },
      });
      //this.$emit('addLicenceAccount', {year:this.year , keyword:this.keyword, accounting_period:this.accounting_period});
    },
    //MARK: Methods
  }
};


</script>

<style lang="scss">
.cmp-catalog-licence-add-account {
}
</style>